import { LazyAction, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "Sweep" */ './lazyIndex');
});
export var lazyShowSweepDialog = new LazyAction(lazyModule, function (m) { return m.showSweepDialog; });
//# sourceMappingURL=index.js.map